module.exports = __webpack_public_path__ + "img/lnr-license.551004e2.svg";